import { render, staticRenderFns } from "./IncomeRecurrentServices.vue?vue&type=template&id=28db7045"
import script from "./IncomeRecurrentServices.vue?vue&type=script&lang=js"
export * from "./IncomeRecurrentServices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports